import { defineMessages } from 'react-intl';

export default defineMessages({
    signUpToContinue: {
        defaultMessage: 'Sign up to continue',
        description: 'Complete sign up form sub title',
        id: 'cv.complete.sign.up.sub.title',
    },
});
